const customSelectors = {};
class customJS {
    constructor() {
      if(document.querySelectorAll(".flatpickr-input").length > 0){
        document.querySelectorAll(".flatpickr-input").forEach(dateInput=>{
          flatpickr(dateInput, { minDate: "today" ,dateFormat: "m/d/Y"});  // flatpickr
        })
        if (document.querySelector('[data-check-events]') != null) {
          function formatCurrentDate(date_selected) {
              const today = new Date(date_selected);
              let dd = today.getDate();
              let mm = today.getMonth() + 1;
              
              let yyyy = today.getFullYear();
              
              if (dd < 10) {
                  dd = '0' + dd;
              }
              if (mm < 10) {
                  mm = '0' + mm;
              }
              const formattedDate = yyyy + '-' + mm + '-' + dd;
              return formattedDate;
          }
          document.querySelector('[data-check-events]').addEventListener('click',function(e){
            // e.preventDefault();
            let startDate = document.querySelector('[name="start-date"]')
            let endDate = document.querySelector('[name="end-date"]')
            if(startDate.value == ''){
              startDate.closest('div').querySelector('.contact__field-error span').classList.remove('visually-hidden')
              return
            }
            if(endDate.value == ''){
              endDate.closest('div').querySelector('.contact__field-error span').classList.remove('visually-hidden')
              return
            }
            
            let eventLIst = document.querySelector('[data-events_list]').textContent.split(",,")
            let eventsHTML = ''

            let eventArray = [];
            eventLIst.forEach((event,idx)=>{
              let temp = event.trim().split('",')
              let dates = temp[1].split('-')
              
              if(new Date(dates[0]).getTime() >= new Date(startDate.value).getTime() && new Date(dates[1]).getTime() <= new Date(endDate.value).getTime() ){
                let month1 = new Date(dates[0]).toLocaleString('default', { month: 'long' });
                let month2 = new Date(dates[1]).toLocaleString('default', { month: 'long' });
                let eventIbj = {};
                eventIbj.month1 = month1.slice(0,3);
                eventIbj.month1_date = formatCurrentDate(dates[0]);
                eventIbj.month2 = month2.slice(0,3);
                eventIbj.month2_date = formatCurrentDate(dates[1]);
                eventIbj.tempName = temp[0].replace(/["[]/g,'');
                eventIbj.tempMsg = temp[2].slice(0,-2).replace(/["]/g,'');
                eventArray.push(eventIbj);
              }
            });
            
            eventArray = eventArray.sort((a, b) => new Date(a.month1_date) - new Date(b.month1_date));
            eventArray.forEach((event,index) => {
              eventsHTML += `<div class="row event-row no-gutter">
                                <div class="col-4">
                                    <div class="event-detail">
                                        ${event.tempName}
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="event-detail">
                                    ${event.month1}. ${new Date(event.month1_date).getDate()} - ${event.month2}. ${new Date(event.month2_date).getDate()}
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="event-detail">
                                    ${event.tempMsg}
                                    </div>
                                </div>            
                            </div>`;
            });
            window.scrollTo({ top: document.querySelector('#eventsList').offsetTop, behavior: 'smooth' });
            document.querySelector('.event-list').classList.remove('d-none')
            if (eventArray.length > 0) {
              document.querySelector('.event-innerHTML').innerHTML = eventsHTML;
              document.querySelector('.event-row').classList.remove('d-none');
            } else {
              document.querySelector('.event-innerHTML').innerHTML = `<p style="
                                                                          text-align: center;
                                                                          margin-top: 15px;
                                                                          font-size: 24px;
                                                                          font-weight: bold;
                                                                      ">No result found.</p>`;
              document.querySelector('.event-row').classList.add('d-none');
            }
            
          });
        }
      }

      document.addEventListener('DOMContentLoaded', function() {
        if (document.querySelector('.read_more')) {
          document.querySelectorAll('.read_more').forEach(ele => {
            ele.addEventListener('click', (e) => {
              e.preventDefault();
              let element = e.target;
              let contentBlock = element.closest('.banner__text')?.querySelector('.content-div');
              
              if (contentBlock) {
                const isOpen = contentBlock.classList.contains('show-more');
                let contentBlockHeight = contentBlock.scrollHeight;
                
                if (!isOpen) {
                  contentBlock.style.height = contentBlockHeight + 'px';
                  setTimeout(() => {
                    contentBlock.style.height = '';
                  }, 300);
                  contentBlock.classList.add('show-more');
                  
                  const dataLess = element.getAttribute('data-less');
                  if (dataLess) {
                    element.closest('[data-hide-show]').innerHTML = dataLess;
                  }
                } else {
                  contentBlock.style.height = contentBlockHeight + 'px';
                  setTimeout(() => {
                    contentBlock.style.height = '190px';
                  }, 1);
                  setTimeout(() => {
                    contentBlock.classList.remove('show-more');
                    const dataRead = element.getAttribute('data-read');
                    if (dataRead) {
                      element.closest('[data-hide-show]').innerHTML = dataRead;
                    }
                  }, 300);
                }
              }
            });
          });
        }
      });
      

  }
}

typeof customJS !== 'undefined' && new customJS();
